import React from 'react';

import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerInbodyAccountCard } from './CustomerInbodyAccountCard/CustomerInbodyAccountCard';
import { useCustomerInbodyAccounts } from './hooks/useCustomerInbodyAccounts';

type NgzCustomerInbodyAccountsWidgetProps = {
  customerId: string;
};

const NgzCustomerInbodyAccountsWidget = ({
  customerId,
}: NgzCustomerInbodyAccountsWidgetProps) => {
  const {
    inbodyAccounts,
    handleRefreshInbodyAccountData,
    handleRequestInbodyAccountAccess,
  } = useCustomerInbodyAccounts(customerId);

  return (
    <>
      {inbodyAccounts.map((inbodyAccount) => (
        <CustomerInbodyAccountCard
          key={inbodyAccount.inbodyKeyId}
          inbodyAccount={inbodyAccount}
          onRefreshInbodyAccountData={handleRefreshInbodyAccountData}
          onRequestInbodyAccountAccess={handleRequestInbodyAccountAccess}
        />
      ))}
    </>
  );
};

angularizeWithProviders(
  NgzCustomerInbodyAccountsWidget,
  'ngzCustomerInbodyAccountsWidget',
  {
    customerId: '<',
  },
);

export { NgzCustomerInbodyAccountsWidget };
